import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuthContext } from '../../services/AuthService';
import { buildLoginRedirect } from './authRedirect';

const RequireAuth = ({ children }) => {
    const auth = useAuthContext();
    const location = useLocation();

    if (!auth.state.isAuthenticated) {
        return (
            <Navigate
                to={buildLoginRedirect(location)}
                replace
                state={{ from: location }}
            />
        );
    }

    return children;
};

export default RequireAuth;
